import { Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-add-recurrence-modal',
  templateUrl: './add-recurrence-modal.component.html',
  styleUrls: ['../../../shared/styles/confirm-dialog.css',
  '../../../shared/styles/filters.css',
  '../../../shared/styles/translation.css']
})
export class AddRecurrenceModalComponent {

  @Output() close: EventEmitter<boolean> = new EventEmitter();

  closeModal(emitValue: boolean) {
    this.close.emit(emitValue);
  }

}
